
import userService from "@/api/userService";
let userInfo = {};
let accessToken = "";
try {
	accessToken = localStorage.getItem("accessToken") || "";
	userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
} catch (err) {
	console.log("err====>", err)
}
const state = {
	accessToken,
	userInfo,
};

const getters = {
	accessToken: state => state.accessToken,
	userInfo: state => state.userInfo,
};

const actions = {
	loginService({ commit }, data) {
		return new Promise((resolve, reject) => {
			userService.loginService(data).then((res) => {
				commit("setAccessToken", res.access_token);
				resolve(res.access_token);
			}).catch((err) => {
				reject(err);
			});
		});
	},
	loginWithCodeService({ commit }, data) {
		return new Promise((resolve, reject) => {
			userService.loginWithCodeService(data).then((res) => {
				// Eslint-disabled-next-line
				commit("setAccessToken", res.access_token);
				resolve(res.access_token);
			}).catch((err) => {
				reject(err);
			});
		});
	},
	getUserInfoService({ commit }, data) {
		return new Promise((resolve, reject) => {
			userService.getUserInfoService(data).then((res) => {
				commit("setUserInfo", res);
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
		});
	},
};

const mutations = {
	setAccessToken(state, token) {
		localStorage.setItem("accessToken", token);
		state.accessToken = token;
	},
	setUserInfo(state, userInfo) {
		localStorage.setItem("userInfo", JSON.stringify(userInfo));
		state.userInfo = userInfo;
	},
};

export default {
	actions,
	getters,
	state,
	mutations,
};
